import {
  Component,
  OnInit,
  ViewChild,
  OnDestroy,
  ViewEncapsulation
} from "@angular/core";
import { AuthService } from "../auth/auth.service";
import { Router, NavigationEnd } from "@angular/router";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { Observable } from "rxjs";
import { MatDialog } from "@angular/material";

import { map, filter } from "rxjs/operators";

import { AuthorizationComponent } from "../auth/authorization/authorization.component";
import { AppTranslationService } from "../service/app-translation.service";
import { ConfigurationService } from "../service/configuration.service";
import { SelectDirective } from "../directives/select.directive";
import { DataService } from "../service/buildings.service";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"]
})
export class HeaderComponent implements OnInit, OnDestroy {
  navItems: Object = [
    { path: "/buy", text: "Sotib Olish", active: false },
    { path: "/rent", text: "Ijara", active: false },
    { path: "/sell", text: "Sotish", active: false }
    // { path: '/mortgages', text: 'Mortgages', active: false }
  ];
  languageChangedSubscription: any;
  isAuthorized = false;
  navExpand = false;
  lang: any;

  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(map(result => result.matches));
  @ViewChild("languageSelector")
  languageSelector: SelectDirective;
  constructor(
    private breakpointObserver: BreakpointObserver,
    public dialog: MatDialog,
    private auth: AuthService,
    private translationService: AppTranslationService,
    private router: Router,
    private service: DataService,
    public configurations: ConfigurationService
  ) {
    translationService.addLanguages(["en", "uz", "ru"]);
    translationService.setDefaultLanguage("uz");

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(res => {
        if (this.router.url === "/buy" || this.router.url === "/rent") {
          this.navExpand = true;
        } else {
          this.navExpand = false;
        }
      });
  }
  changeLanguage(lang) {
    this.configurations.language = lang;
    console.log("change langulage:");
    console.log("lang:" + lang);

    this.service.changeLang(lang).subscribe(
      next => {
        console.log("Success:" + next);
      },
      error => {
        console.log("Error:" + JSON.stringify(error));
        if (error.status == 200) {
          this.router.navigate(["/home"]);
        }
      }
    );
  }

  ngOnInit() {
    this.languageChangedSubscription = this.translationService.languageChanged$.subscribe(
      data => {
        setTimeout(() => {
          console.log("here");
          this.languageSelector.refresh();
        });
      }
    );
  }
  ngOnDestroy() {
    this.languageChangedSubscription.unsubscribe();
  }
  loginDialog(): void {
    this.dialog.open(AuthorizationComponent, {
      panelClass: "auth-class",
      autoFocus: false
    });
  }
  signOut() {
    this.auth.signOut();
  }
}
